export const skymonBlue = "#4686BA";
export const superAdminColor = "#af7ac5";
export const superAdminColorLight = "#eabde6";
export const editModeColor = "darkgoldenrod";
export const nonActiveColor = "darkGrey";
export const titleText = "darkGrey";
export const dataText = "#34495E";
export const data2Text = "#5D6D7E"
export const dialogBg = "rgba(33, 47, 60, 0.95)";
export const blueShades = ["#aed6f1", "#85c1e9", "#5dade2", "#3498db", "#2e86c1", "#2874d3", "#2161c3", "#1b4fad", "#163f87", "#12316d"];
export const colorPalette2025 = ["#f0e9e0", "#899f6a", "#7391c9", "#a793b9", "#d19c97", "#a47764", "#a89a8f", "#9a8b4e"];